export default [
    {
        path: 'tabela-cid',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-tabela-cid' */
            '@/views/parametrizacao/tabela-cid/Index.vue'
        ),
        redirect: 'tabela-cid/index',
        children: [
            {
                name: 'parametrizacao-tabela-cid-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-tabela-cid' */
                    '@/views/parametrizacao/tabela-cid/List.vue'
                ),
            },
        ],
    },
]